import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'Euro',
      title: 'Finanzielle Vorteile',
      description: 'Profitieren Sie jährlich von der THG-Quote für Ihr Elektrofahrzeug.'
    },
    {
      icon: 'FileCheck',
      title: 'Keine Bürokratie',
      description: 'Wir übernehmen Antrag, Prüfung und Handel des CO₂‑Zertifikats.'
    },
    {
      icon: 'Shield',
      title: 'Sicher & transparent',
      description: 'Datenschutzkonform, zuverlässig und ohne versteckte Kosten.'
    },
    {
      icon: 'Zap',
      title: 'Einfacher Prozess',
      description: 'Schnelle Abwicklung durch unsere Partnerautohäuser.'
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            Ihre Vorteile mit Grid Balance
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Profitieren Sie von unserem professionellen Service und sichern Sie sich Ihre THG-Prämie
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth"
            >
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                style={{ backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name={benefit?.icon} size={24} color="var(--color-primary)" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                {benefit?.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;